import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Image } from 'components/ui';
import {
    buttons, colors, mediaQueries, radii, space
} from 'style/config';
import pazeUtils from 'utils/Paze';
import LOCAL_STORAGE from 'utils/localStorage/Constants';
import Storage from 'utils/localStorage/Storage';

const getPazeVisibility = () => {
    const { isPazeDynamic } = Sephora.configurationSettings;
    const shouldShowPaze = pazeUtils.isPazeVisible();
    let isPazeVisible = false;

    if (isPazeDynamic && shouldShowPaze) {
        const canCheckoutPaze = Storage.local.getItem(LOCAL_STORAGE.CAN_CHECKOUT_PAZE);
        isPazeVisible = canCheckoutPaze;
    } else {
        isPazeVisible = shouldShowPaze;
    }

    return isPazeVisible;
};

/**
 * Paze Pill Button - Release 4 Style
 * Renders as a pill-shaped button with Paze logo
 */
const PazePill = props => {
    const { isPazeEnabledForThisOrder, handlePaymentClick } = props;

    // Don't render if the current user is not eligible for Paze (canCheckoutPaze)
    if (!getPazeVisibility()) {
        return null;
    }

    // Don't render if Paze is not enabled for this order
    if (!isPazeEnabledForThisOrder) {
        return null;
    }

    return (
        <Button
            variant='primary'
            onClick={handlePaymentClick}
            data-at={Sephora.debug.dataAt('paze_button')}
            aria-label='Pay with Paze'
            css={styles}
            width={['100%', '151px', '100%']}
        >
            <Image
                src='/img/ufe/logo-paze-white.svg'
                alt=''
                aria-hidden='true'
                height='16px'
                width='52px'
                css={styles.logo}
            />
        </Button>
    );
};

const styles = {
    backgroundColor: colors.pazeBlue,
    borderRadius: radii.full,
    height: buttons.HEIGHT,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${space[2]}px ${space[5]}px`,
    gap: space[3],
    flexShrink: 0,
    [mediaQueries.xsMax]: {
        padding: `${space[2]}px ${space[4]}px`
    },
    '&:hover': {
        backgroundColor: colors.pazeBlue
    },
    logo: {
        transform: 'translateY(1px)'
    }
};

export default wrapFunctionalComponent(PazePill, 'PazePill');
